function SessionSendRequest(path, message, recipient) {
    this.path = path;
    this.message = message;
    this.recipient = recipient;
}

module.exports = SessionSendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/session-send-request.js
// module id = 314
// module chunks = 1